var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"renderContainer",staticClass:"relative h-full",attrs:{"id":"ortho"}},[_c('div',{staticClass:"absolute top-2 right-2 bg-neutral-700 text-white text-xs px-3 py-1 rounded",staticStyle:{"border-top":"2px solid #27bdf4"}},[_vm._v(" Orthomosaic ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }